<template>
  <span>
    <aha-button
      class="flex relative items-center justify-center"
      :variant="variant"
      :disabled="disabled"
      @click="handleButtonClick"
    >
      <slot />
      <span class="h-6 border-r-0.5 border-secondary-20 ml-1.5 mr-2" />
      <div class="relative">
        <aha-icon
          class
          name="arrow"
          width="14"
          height="14"
          viewBox="0 0 24 24"
        />
        <div
          v-if="dropdownVisible"
          class="top-8 absolute -right-3"
        >
          <slot name="dropdown" />
        </div>
      </div>
    </aha-button>
  </span>
</template>

<script>
import AhaButton from './Button.vue'
import AhaIcon from './Icon.vue'

export default {
  components: {
    AhaButton,
    AhaIcon,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'base',
    },
  },
  data() {
    return {
      dropdownVisible: false,
    }
  },
  methods: {
    handleButtonClick() {
      this.dropdownVisible = !this.dropdownVisible
      this.$emit('click')
    },
  },
}
</script>
